import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const assetNotesListTodo = createAsyncThunk('assetNotesList', async ({ pageable: data, navigate }) => {
    // console.log(data)
    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `asset_note`,
            params: {
                "assetDetailId": data,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const assetNotesListSlice = createSlice({
    name: 'assetNotesList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(assetNotesListTodo.fulfilled, (state, action) => {
           if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                 showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(assetNotesListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default assetNotesListSlice.reducer; 